import axios from 'axios'

import { Toast   } from 'vant'

const request = axios.create({
  // baseURL: 'https://xyapi.zonln.cn/api.php/',
  baseURL: "https://xyapi.xyyysp.com/api.php/"
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')
    if (token) {
    } else {
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// 响应拦截器
request.interceptors.response.use(
  res => {
    if (res.status === 200) {
      if (res.data.code === 2045) {
        if (localStorage.getItem('token')) {
          localStorage.setItem('token', '')
          Toast  ({
            message:'登录失效/未登录,请先登录!',
            duration: 2000
          })
          setTimeout(() => {
            window.location.href = location.protocol + '//' + location.host
          }, 1000)
        } else{
          return Promise.resolve(res)
        }
      } else {
        return Promise.resolve(res)
      }
    } else {
      Promise.reject(res)
    }
  },
  err => {
    return Promise.reject(err)
  }
)
export default request
